import React from "react";
import "./boqInfo.css";
import { boqINFO } from "../Design&Structure/structureFunction";

export default function MultipleSelection({ roofDetail }) {
  const list = roofDetail.multipleStructure;

  return (
    <div className="boqInfoContainer">
      {list?.map((data, i) => {
        return (
          <>
            {boqINFO[data?.structureType]?.map((item, j) => {
              return (
                <ul className="boqTableBody" key={`${(i + 1) * (j + 1)}`}>
                  <li>{item.serialNo}</li>
                  <li>
                    {item.img ? <img src={item.img} alt="images" /> : "--"}
                  </li>
                  <li>{item.name}</li>
                  <li>
                    {
                      //eslint-disable-next-line no-new-func
                      Function("data", `return ${item.val}`)(data)
                    }
                  </li>
                </ul>
              );
            })}
          </>
        );
      })}
    </div>
  );
}
